export const GET_IVS_PLAYBACK_TOKEN = /* GraphQL */`
query getIVSPlaybackToken {
  getIVSPlaybackToken{
    playbackUrl
    playbackToken
  }
}
`

export const SUBSCRIBE_STREAM_STATUS = /* GraphQL */ `
subscription OnStreamStatusChange {
  onStreamStatusChange
}
`;

export const SUBSCRIBE_STREAM_VIEWER_COUNT = /* GraphQL */ `
subscription onConcurrentViewers {
  onConcurrentViewers {
    count
    timestamp
  }
}
`;

export const GET_IVS_CHAT_ROOM_TOKEN = /* GraphQL */ `
query getChatToken {
  getChatToken {
    roomToken
    tokenExpirationTime
  }
}
`;

export const SUBSCRIBE_EMOJI_REACTIONS = /* GraphQL */ `
subscription onEmojiCounts {
  onEmojiCounts {
    counts {
      emoji
      count
    }
    timestamp
  }
}
`;

export const RECORD_EMOJI_CLICK = /* GraphQL */ `
query RecordEmojiClick($emoji: [EmojiType!]!) {
  recordEmojiClick(emoji: $emoji)
}
`;